import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import BoxFiles from './BoxFiles';

const BoxFilesGet = ({ boxId }) => {

    const [open, setOpen] = useState(false)

  return (
     <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            <AttachFileIcon />
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header='Отримання файлів за цією коробкою'
            disableClickOutside={true}
            content={
                <BoxFiles
					boxId={boxId}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default BoxFilesGet